export default __webpack_public_path__ + "static/media/ChangeIcon.60bcbe26.svg";